<template>
  <div class="bikelist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('bike.name30')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" @change="handleChange1" clearable collapse-tags :show-all-levels="false" :props="{ lazy: true, multiple: true, checkStrictly: true, lazyLoad: loadOptions }"></el-cascader>
        </el-form-item>
          <!-- <el-form-item :label="$t('bike.name31')" prop="controllerEdition">
            <el-input v-model="queryInfo.controllerEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('bike.name32')" prop="meterEdition">
            <el-input v-model="queryInfo.meterEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('bike.name33')" prop="iotEdition">
            <el-input v-model="queryInfo.iotEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <el-form-item :label="$t('finance.name33')" prop="ebikeId">
              <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>

          <el-form-item :label="$t('bike.name295')" prop="ebikeCode">
              <el-input v-model="queryInfo.ebikeCode" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name35')" prop="status">
            <el-select :key="'bike-status-' + $i18n.locale" v-model="queryInfo.status" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div class="add-user">
      <el-button type="primary" size="medium" @click="importBikeFactoryDialog" v-if="buttonPerms.indexOf('bike/importVehicleFactoryInformation') > -1">{{ $t('bike.name400') }}</el-button>
      <el-button type="primary" size="medium" @click="showAddIotNum" v-if="buttonPerms.indexOf('ebike/tenantBindEbike') > -1">{{ $t('bike.name156') }}</el-button>
      <el-button size="medium" type="primary" @click="exportEbikeData"  :loading='exportLoading'>{{ $t('bike.name159') }}</el-button>
      <el-button type="primary" size="medium" @click="showModeBindDialog" v-if="buttonPerms.indexOf('ebikeModel/bindModel') > -1" >{{ $t('bike.name115') }}</el-button>
      <!-- <el-button type="primary" size="medium" @click="showVersionConfigurationDialog">{{ $t('bike.name118') }}</el-button> -->
      <el-button type="primary" size="medium" @click="changeTransportMode" :loading='loading1' v-if="buttonPerms.indexOf('ebike/sendTransportInfo') > -1">{{ $t('bike.name117') }}</el-button>
      <el-button type="primary" size="medium" @click="showFiveCodeDialog" v-if="buttonPerms.indexOf('ebike/importEbikeVin') > -1">{{ $t('bike.name116') }}</el-button>
      <el-button type="primary" size="medium" @click="showImportIotNum" v-if="buttonPerms.indexOf('ebike/importTenantBindEbike') > -1">{{ $t('bike.name157') }}</el-button>
      <el-button size="medium" type="primary" @click="showIOTDialog" v-if="buttonPerms.indexOf('ebike/importIOT') > -1">{{ $t('bike.name158') }}</el-button>
      <el-button size="medium" type="primary" @click="showAddBikeDialog" v-if="buttonPerms.indexOf('ebike/addBike') > -1">{{ $t('bike.name3') }}</el-button>
      <el-button type="primary" size="medium" @click="importBikeInfoDialog" v-if="buttonPerms.indexOf('bike/importVehicleInformation') > -1">{{ $t('bike.name212') }}</el-button>
      <el-button type="primary" size="medium" @click="importProductDialog" v-if="buttonPerms.indexOf('bike/importProductQualityCertificate') > -1">{{ $t('bike.name213') }}</el-button>
    </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top:15px;">
    <el-tab-pane label="IOT" name="first"></el-tab-pane>
    <el-tab-pane :label="$t('bike.name573')" name="second"></el-tab-pane>
  </el-tabs>
    <el-table ref="table"   :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading" @selection-change="onSelectTab">
      <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable min-width="180" fixed="left"></el-table-column>
      <el-table-column :label="$t('bike.name376')" prop="iotVersionNo" sortable min-width="180"></el-table-column>
      <el-table-column :label="$t('bike.name377')" prop="iotHwVersionNo" sortable min-width="180"></el-table-column>
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.tenantName || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name40')" prop="mac" sortable min-width="150"></el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.ebikeCode || '—' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name43')" prop="controllerVersion" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.controllerVersion || '—' }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name106')" prop="meterNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.meterNo || '—' }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name107')" prop="iotVersionNo" sortable min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.iotVersionNo || '—' }}</div>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('bike.name52')" prop="ebikeModelName" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.ebikeModelName || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.ebikeModelId || '—' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name108')" prop="ebikeVinNo" sortable min-width="150"></el-table-column> -->
      <el-table-column :label="$t('bike.name109')" prop="motorNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.motorNo || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name307')" prop="controllerNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.controllerNo || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name308')" prop="batteryNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.batteryNo || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name309')" prop="meterNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.meterNo || '—' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="合格证编号" prop="cccCode" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.cccCode || '—' }}</div>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('bike.name110')" prop="remark" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.remark || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name111')" prop="isTransport" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.isTransport === 0 ? $t('bike.name251') : $t('bike.name252') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name112')" prop="status" sortable min-width="120">
        <template slot-scope="scope">
          <div class="green" v-if="scope.row.status === 1">
            <div class="text">{{ $t('bike.name45') }}</div>
          </div>
          <div class="red" v-if="scope.row.status === 0">
            <div class="text">{{ $t('bike.name113') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name44')" prop="test" sortable min-width="180">
        <template slot-scope="scope">
          {{ [$t('bike.name251'),$t('bike.name252')][scope.row.isTest] }}
          <!-- <el-switch class="switch" :value="scope.row.isTest" :active-value="1"  :inactive-value="0" active-color="#0f73e6" inactive-color="#dcdfe6"   :active-text="$t('bike.name252')"  :inactive-text="$t('bike.name251')"> </el-switch> -->
        </template>
      </el-table-column>
      <!-- 海外：锁车状态放在「测试机」列后 -->
      <el-table-column v-if="isOverseas" :label="$t('bike.name607')" prop="lockStatus" min-width="120">
        <template slot-scope="scope">
          {{ lockStatusLabel(scope.row.lockStatus) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name11')" :min-width="isOverseas ? 220 : 200" fixed="right">
        <template slot-scope="scope">
          <!-- 详情：国内/海外均行外 -->
          <el-button type="text" @click="showDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/findEbikeDetail') > -1">{{ $t('bike.name46') }}</el-button>
          <!-- 海外行外：开关锁 -->
          <el-button
            v-if="isOverseas && canToggleLockFor(scope.row.lockStatus)"
            type="text"
            :disabled="isControlPending(scope.row.ebikeId)"
            @click="handleToggleLock(scope.row)"
          >{{ toggleLockLabel(scope.row.lockStatus) }}</el-button>
          <!-- 国内：原行外按钮布局不变 -->
          <template v-if="!isOverseas">
            <el-button type="text" @click="showIotDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/getIotDetalis') > -1">IOT</el-button>
            <el-button type="text" @click="handleCancelBindModel(scope.row)" v-if="buttonPerms.indexOf('ebikeModel/cancelBindModel') > -1">{{ $t('bike.name114') }}</el-button>
            <el-button type="text" @click="showCertificateDialog(scope.row)" v-if="scope.row.eccId">{{ $t('bike.name214') }}</el-button>
            <el-button type="text" @click="resetIOT(scope.row)" v-if="buttonPerms.indexOf('bike/resetIOT') > -1">{{ $t('bike.name531') }}</el-button>
          </template>
          <!-- 海外行外：取消绑定车型（方案 A，保留） -->
          <el-button
            v-if="isOverseas && buttonPerms.indexOf('ebikeModel/cancelBindModel') > -1"
            type="text"
            @click="handleCancelBindModel(scope.row)"
          >{{ $t('bike.name114') }}</el-button>
          <!-- 海外三点：IOT、生产信息、擦除、IOT重置、解锁电池、锁定电池 -->
          <el-dropdown
            v-if="isOverseas"
            trigger="click"
            placement="bottom-end"
            @command="handleOverseasIotMenuCommand($event, scope.row)"
          >
            <span class="control-more-trigger" :class="{ 'is-disabled': isControlPending(scope.row.ebikeId) }">
              <i class="el-icon-more" :class="{ 'el-icon-loading': isControlPending(scope.row.ebikeId) }"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="buttonPerms.indexOf('ebike/getIotDetalis') > -1"
                command="iot"
              >IOT</el-dropdown-item>
              <el-dropdown-item
                v-if="scope.row.eccId"
                command="production"
              >{{ $t('bike.name214') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="canShowOverseasErase"
                command="erase"
                :disabled="isControlPending(scope.row.ebikeId)"
              >{{ $t('bike.name610') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="canShowOverseasReset"
                command="reset"
                :disabled="isControlPending(scope.row.ebikeId)"
              >{{ $t('bike.name531') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="buttonPerms.indexOf('ebikeControl/remoteUnlockBattery') > -1"
                command="remoteUnlockBattery"
                :disabled="isControlPending(scope.row.ebikeId)"
              >{{ $t('bike.name590') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="buttonPerms.indexOf('ebikeControl/remoteLockBattery') > -1"
                command="remoteLockBattery"
                :disabled="isControlPending(scope.row.ebikeId)"
              >{{ $t('bike.name591') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--车型绑定-->
    <AppDialog size="sm" :title="$t('bike.name120')" :visible.sync="vehicleModelBindingDialog" v-if="vehicleModelBindingDialog" :before-close="close" >
      <el-form ref="bindingFormRef" :label-width="formLabelWidth()" :model="bindingForm" :rules="bindingFormRules">
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
           <el-select v-model="bindingForm.ebikeModelId" :placeholder="$t('public.name1')">
              <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="bindingVehicleMode" :loading='loading'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--分配运营商-->
    <AppDialog size="sm" :title="$t('bike.name119')" :visible.sync="assignOperatorsDialog" v-if="assignOperatorsDialog" :before-close="close" >
      <el-form ref="assignOperatorsFormRef" :label-width="formLabelWidth()" :model="assignOperatorsForm"   :rules="assignOperatorsFormRules">
        <el-form-item :label="$t('bike.name406')" prop="tenantId">
          <el-select v-model="assignOperatorsForm.tenantId" :placeholder="$t('public.name1')">
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitAssignOperators" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--导入IOT-->
      <AppDialog size="sm" :title="$t('bike.name158')" :visible.sync="iotDialog" v-if="iotDialog" :before-close="close" >
      <el-form ref="iotFormRef" :label-width="formLabelWidth('lg2')" >
        <el-form-item :label="$t('bike.name100')">
          <a :href="importIotPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" prop="fiveWayCodeFile" style="width:100%;">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>
         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile3" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

     <!--版本配置-->
     <AppDialog size="sm" :title="$t('bike.name118')" :visible.sync="versionConfigurationDialog" v-if="versionConfigurationDialog" :before-close="close" >
      <el-form ref="versionConfigurationFormRef" :label-width="formLabelWidth()" :model="versionConfigurationForm"  :rules="versionConfigurationFormRules">
        <el-form-item :label="$t('manage.name44')" prop="hardwareType">
            <el-select :key="'bike-hw-type-' + $i18n.locale" v-model="versionConfigurationForm.hardwareType" :placeholder="$t('public.name1')" @change="changeType">
              <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('bike.name21')" prop="otaFirewareInfoId">
            <el-select v-model="versionConfigurationForm.otaFirewareInfoId" :placeholder="$t('public.name1')">
              <el-option v-for="item in versionNumberOptions" :key="item.name" :label="item.id" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitVersionConfiguration" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--导入五通码-->
      <AppDialog size="sm" :title="$t('bike.name576')" :visible.sync="fiveWayCodeUploadDialog" v-if="fiveWayCodeUploadDialog" :before-close="close" >
      <el-form :label-width="formLabelWidth('lg2')">
        <el-form-item :label="$t('bike.name574')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BA%94%E9%80%9A%E7%A0%81EXCEL%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx?Expires=2365230403&OSSAccessKeyId=ULZah0Yxq41iLeaf&Signature=gstHMnwITJS8aCNBItkF%2BYpURqQ%3D">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name575')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile1" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

    <!--导入分配归属-->
    <AppDialog size="sm" :title="$t('bike.name157')" :visible.sync="importIotNumDialog" v-if="importIotNumDialog" :before-close="close" >
      <el-form :label-width="formLabelWidth('lg2')" ref="importBelongFormRef"  :rules="importBelongFormRules"  :model="importBelong">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name160')" prop="tenantId">
          <el-cascader ref="refHandle" v-model="importBelong.tenantId" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" >
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile2" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

    <!--分配归属-->
    <AppDialog size="sm" :title="$t('bike.name156')" :visible.sync="addIotNumDialog" v-if="addIotNumDialog" :before-close="close" >
      <el-form ref="belongFormRef"  :label-width="formLabelWidth('lg2')" :rules="belongFormRules"  :model="belong">
        <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="belong.tenantId" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>

        <!-- <el-form-item :label="$t('bike.name98')">
          <el-input v-model="queryInfo.loginName" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('bike.name99')">
          <el-switch
            v-model="queryInfo.status"
            active-color="#0f73e6"
            inactive-color="#dcdfe6"
            active-value="1"
            inactive-value="0"
            :active-text="$t('bike.name45')"
            :inactive-text="$t('bike.name104')"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitBelong" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
     <!--车辆详情-->
     <VehicleDetailsAppDialog
       ref="vehicleDetailsDialog"
       :visible.sync="eBikeDetailsDialog"
       :e-bike-id="eBikeBaseInfo.ebikeId"
       :e-bike-code="eBikeBaseInfo.ebikeCode"
       :type="type"
       @list-changed="queryList"
     />
      <!--修改车辆基本信息-->
      <AppDialog size="sm" :title="$t('bike.name162')" :visible.sync="eBikeBaseInfoDialog" v-if="eBikeBaseInfoDialog" :before-close="closeBaseInfoDialog" >
        <el-form :label-width="formLabelWidth()" style="width:100%;" :model="eBikeBaseInfo">
          <!-- <el-form-item label="web配置：">
            <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="eBikeBaseInfo.webConfiguration">
          </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('manage.name78')">
            <el-input
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            :placeholder="$t('public.name5')"
            v-model="eBikeBaseInfo.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="handlerDelBike" :loading="loading3" v-if="userinfo.tenantType === 0">{{ $t('bike.name253') }}</el-button>
        <el-button type="primary" @click="handlerModify" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBaseInfoDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--IOT详情-->
      <AppDialog :title="$t('bike.name254')" :visible.sync="iotDetailsDialog" v-if="iotDetailsDialog" size="lg" :before-close="closeIotDetailsDialog">
        <IotDetailsDialog ref="iotDetailsDialogRef" :ebike-id="iotEbikeId"></IotDetailsDialog>
      <template #footer>
        <el-button @click="closeIotDetailsDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
     <!--添加车辆-->
     <AppDialog size="sm" :title="$t('bike.name3')" :visible.sync="addBikeDialog" v-if="addBikeDialog" :before-close="closeAddBikeDialog" >
        <el-form :label-width="formLabelWidth('xl')" style="width:100%;" :model="addEBikeInfo" :rules="addBikeFormRules" ref="addBikeRef">
          <!-- <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader ref="refHandle" :show-all-levels="false" style="width:80%"   @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name65')" prop="ebikeId">
            <el-input
            style="width:80%"
            :placeholder="$t('public.name5')"
            v-model="addEBikeInfo.ebikeId">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="MAC地址：" prop="mac">
            <el-input
             style="width:80%"
            placeholder="请输入内容"
            v-model="addEBikeInfo.mac">
          </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name379')" prop="testStatus">
          <el-switch class="switch" v-model="addEBikeInfo.testStatus"  active-color="#0f73e6" inactive-color="#dcdfe6"   :active-text="$t('bike.name252')"  :inactive-text="$t('bike.name251')"> </el-switch>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="handlerAddBike" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeAddBikeDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--导入产品质量合格证-->
      <AppDialog size="sm" :title="$t('bike.name213')" :visible.sync="productUploadDialog" v-if="productUploadDialog" :before-close="closeProductUpload" >
      <el-form :label-width="formLabelWidth('xxl')">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%90%88%E6%A0%BC%E8%AF%81-%E6%A8%A1%E6%9D%BF.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name405')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile4" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeProductUpload">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

     <!--导入车辆信息-->
     <AppDialog size="sm" :title="$t('bike.name398')" :visible.sync="bikeUploadDialog" v-if="bikeUploadDialog" :before-close="closeBikeUpload" >
      <el-form :label-width="formLabelWidth('xxl')">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importVehicleInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name404')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile5" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
     <!--导入车辆出厂信息-->
     <AppDialog size="sm" :title="$t('bike.name400')" :visible.sync="bikeFactoryUploadDialog" v-if="bikeFactoryUploadDialog" :before-close="closeBikeUpload" >
      <el-form class="factory-upload-form" :label-width="formLabelWidth('xxl')">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importVehicleFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" id="fileInput">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile6" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
     <!--修改车辆出厂信息-->
     <AppDialog size="sm" :title="$t('bike.name402')" :visible.sync="editEbikeInfoDialog" v-if="editEbikeInfoDialog" :before-close="closeBikeUpload" >
      <el-form class="factory-upload-form" :label-width="formLabelWidth('xxl')">
        <el-form-item :label="$t('bike.name100')">
          <a :href="modifyFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" id="fileInput">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile7" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

    <!--合格证-->
    <AppDialog :visible.sync="certificateDialog" v-if="certificateDialog" size="lg" :before-close="closeCertificateDialog">
      <CertificateDialog :certificate-details="certificateDetails"></CertificateDialog>
    </AppDialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import {
  findEbikePage,
  bindModel,
  cancelBindModel,
  findEbikeDetail,
  sendTransportInfo,
  tenantBindEbike,
  importEbikeVin,
  importTenantBindEbike,
  importEbikeIdMacNoTenantId,
  modifyEbikeBaseInfo,
  findOtaFirmwarePage,
  findEbikeModelPage,
  otaFirmwareInfoList2,
  otaFirmwareInfoList3,
  sendUpgradeInfo,
  exportEbike,
  removeIotEbike,
  addEbike,
  importEbikeBaseInfo,
  importCertificate,
  selecteById,
  importEbikeModelCertificateConformity,
  downloadTempFile,
  queryWebMaintainRecordListByEbikeId,
  resetIotEbike,
  remoteDisable,
  remoteEnable,
  remoteUnlockBattery,
  remoteLockBattery,
  unbindParts,
  getHandleResult
} from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
import { mapGetters } from 'vuex'
import CertificateDialog from './certificateDialog.vue'
import VehicleDetailsAppDialog from '@/components/VehicleDetailsAppDialog.vue'
import IotDetailsDialog from '../components/IotDetailsDialog.vue'
import AppDialog from '@/components/AppDialog/index.vue'
import { isOverseas } from '@/config/flavor'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    // 海外 IOT 重置：仅需 resetIOT 权限（清库，不再串联解绑）
    canShowOverseasReset () {
      return this.buttonPerms.indexOf('bike/resetIOT') > -1
    },
    // 海外擦除：仅 unbindParts
    canShowOverseasErase () {
      return this.buttonPerms.indexOf('ebikeControl/unbindParts') > -1
    },
    statusOptions () {
      return [
        { value: '1', label: this.$t('bike.name45') },
        { value: '0', label: this.$t('bike.name113') }
      ]
    },
    typeAllOptions () {
      return [
        { name: 0, label: 'IOT' },
        { name: 1, label: this.$t('bike.name14') },
        { name: 2, label: this.$t('bike.name413') }
      ]
    }
  },
  data() {
    return {
      isOverseas,
      // 远程指令轮询状态（海外开关锁 / 电池锁 / 擦除）
      controlPending: {},
      controlTimers: {},
      controlActionLabel: {},
      activeName: 'first',
      modifyFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv3.xlsx',
      importIotPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88v2.xlsx',
      importVehicleFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv10.xlsx',
      importVehicleInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BF.xlsx',
      showBaseInfoType: 1,
      type: 1,
      certificateDetails: {},
      tenantIds2: [],
      certificateDialog: false,
      productUploadDialog: false,
      editEbikeInfoDialog: false,
      bikeUploadDialog: false,
      bikeFactoryUploadDialog: false,
      tenantIds: [],
      iotDetailsDialog: false,
      iotEbikeId: '',
      eBikeBaseInfoDialog: false,
      iotDialog: false,
      eBikeBaseInfo: {
        ebikeId: '',
        ebikeCode: '',
        remark: ''
      },
      typeOptions: [],
      loading1: false,
      loading2: false,
      loading3: false,
      exportLoading: false,
      importIotNumDialog: false,
      assignOperatorsDialog: false,
      versionConfigurationDialog: false,
      fiveWayCodeUploadDialog: false,
      eBikeDetailsDialog: false,
      eBikeDetails: {},
      addIotNumDialog: false,
      vehicleModelBindingDialog: false,
      tenantOptions: [],
      manufacturerOptions: [],
      modelOptions: [],
      bindingForm: {
        ebikeModelId: '',
        ebikeIdList: []
        // ebikeVinNo: ''
      },
      fileList: [],
      belong: {
        tenantId: []
      },
      belongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      importBelong: {
        tenantId: []
      },
      importBelongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      bindingFormRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name468'),
            trigger: 'blur'
          }
        ]
      },
      assignOperatorsForm: {
        tenantId: ''
      },
      assignOperatorsFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name469'),
            trigger: 'blur'
          }
        ]
      },
      versionConfigurationForm: {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: []
      },
      versionConfigurationFormRules: {
        otaFirewareInfoId: [
          {
            required: true,
            message: this.$t('bike.name470'),
            trigger: 'blur'
          }
        ],
        hardwareType: [
          {
            required: true,
            message: this.$t('bike.name471'),
            trigger: 'blur'
          }
        ]
      },
      queryInfo: {
        status: '',
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        ebikeCode: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: [],
        bluetoothFlag: '1'
      },
      bluetoothFlag: '1',
      tableLoading: false,
      loading: false,
      selectionList: [],
      total: 0,
      tableList: [],
      options: [],
      ridelist: [
        {
          bikeCode: '',
          email: '',
          remark: '',
          ebikeId: '',
          type: '',
          bikeMac: '',
          status: '',
          isTransport: '',
          controllerEdition: '',
          meterEdition: '',
          iotEdition: '',
          ebikeModelId: '',
          ebikeModelName: '',
          motorNo: '',
          ebikeVinNo: ''
        }
      ],
      isTransportlist: [],

      // 详情提示框
      ebikeId: '',
      dialogBikeInfoVisible: false,
      IOTebikeId: '',
      dialogIoTisible: false,
      // 延迟
      // 车型绑定
      modelist: [],
      modelVisible: false,
      modelFrom: {
        ebikeModelId: '',
        ebikeId: [],
        ebikeVinNo: ''
      },
      modelFromRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name472'),
            trigger: 'blur'
          }
        ]
      },
      // OTA升级
      selectlist: [],
      disposeOTAVisible: false,
      disposeOTAFrom: {
        ebikeId: [],
        hardwareType: '',
        versionNumber: ''
      },
      versionNumberOptions: [],
      TypefirmwareList: [],
      fiveWayCodeFile: null,
      ImportbikeVisible: false,
      buttonPerms: '',
      tenantAllOptions: [],
      addBikeDialog: false,
      addEBikeInfo: {
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      },
      maintenanceRecordList: [],
      maintenanceRecordTotal: 0,
      maintenanceRecord: {
        pageNumber: 1,
        pageSize: 10
      },
      spanArr: [],
      pos: 0,
      uploadTenantId: '',
      addBikeFormRules: {
        // tenantId: [
        //   {
        //     required: true,
        //     message: this.$t('public.name45'),
        //     trigger: 'blur'
        //   }
        // ],
        ebikeId: [
          {
            required: true,
            message: this.$t('bike.name473'),
            trigger: 'blur'
          }
        ],
        // mac: [
        //   {
        //     required: true,
        //     message: this.$t('bike.name479'),
        //     trigger: 'blur'
        //   }
        // ],
        testStatus: [
          {
            required: true,
            message: this.$t('public.name1'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    CertificateDialog,
    VehicleDetailsAppDialog,
    IotDetailsDialog,
    AppDialog
  },
  created () {
    this.updateImportTemplatePaths(localStorage.getItem('lang'))
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  beforeDestroy() {
    this.$bus.$off('lang', this.updateImportTemplatePaths)
    this.clearAllControlTimers()
  },
  mounted() {
    this.$bus.$on('lang', this.updateImportTemplatePaths)
    this.getTenantList()
    this.getEbikeModelList()
    // this.getOtaFirmwareInfoLlist2()
    this.loadOptions1()
    this.activeName = 'first'
    this.bluetoothFlag = '1'
    this.queryInfo.bluetoothFlag = '1'
    this.queryList()
  },
  methods: {
    updateImportTemplatePaths (lang) {
      if (lang === 'en') {
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Modify%20the%20factory%20information%20of%20the%20vehicle-v3.xlsx'
        this.importIotPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20IOT.xlsx'
        this.importVehicleFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20the%20vehicle%27s%20factory%20information-v10.xlsx'
        this.importVehicleInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20vehicle%20information.xlsx'
      } else {
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv3.xlsx'
        this.importIotPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88v2.xlsx'
        this.importVehicleFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv10.xlsx'
        this.importVehicleInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BF.xlsx'
      }
    },
    handleClick() {
      if (this.activeName === 'first') {
        this.bluetoothFlag = '1'
      } else {
        this.bluetoothFlag = '0'
      }
      this.queryInfo.pageNumber = 1
      this.queryInfo.bluetoothFlag = this.bluetoothFlag
      this.queryList()
    },
    resetQuery() {
      this.queryInfo = {
        status: '',
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        ebikeCode: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: [],
        bluetoothFlag: this.bluetoothFlag
      }
      this.tenantIds = []
      this.queryList()
    },
    exportEbikeData() {
      const filter = this.buildIotListExportFilter()
      if (!filter) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.exportLoading = true
      exportEbike(filter).then(res => {
        this.exportLoading = false
        downloadExcel(res, this.$t('bike.name229'))
      }).catch(() => {
        this.exportLoading = false
      })
    },
    /** 导出时读取表格实际选中行（优先 store，兼容 selectionList 未同步） */
    getSelectedBikeRows() {
      const table = this.$refs.table
      const storeSelection = table && table.store && table.store.states && table.store.states.selection
      if (storeSelection && storeSelection.length) {
        return storeSelection
      }
      return this.selectionList
    },
    /**
     * 构建 IOT 列表「导出车辆信息」筛选参数。
     * 有勾选时仅传 ebikeIdList，避免与列表筛选条件 AND 导致 0 行或误导出全量。
     */
    buildIotListExportFilter() {
      const selectedRows = this.getSelectedBikeRows()
      if (selectedRows.length > 0) {
        const ebikeIdList = selectedRows.map((item) => item.ebikeId).filter(Boolean)
        if (!ebikeIdList.length) {
          return null
        }
        const filter = { ebikeIdList }
        if (this.queryInfo.permTenantList && this.queryInfo.permTenantList.length) {
          filter.permTenantList = this.queryInfo.permTenantList
        }
        return filter
      }
      return {
        ...this.queryInfo,
        ebikeId: (this.queryInfo.ebikeId || '').trim(),
        controllerEdition: (this.queryInfo.controllerEdition || '').trim(),
        meterEdition: (this.queryInfo.meterEdition || '').trim(),
        iotEdition: (this.queryInfo.iotEdition || '').trim()
      }
    },
    getEbikeModelList() {
      const queryInfo = {
        pageNumber: 1,
        pageSize: 500
      }
      findEbikeModelPage(queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    showImportIotNum() {
      this.importIotNumDialog = true
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.addIotNumDialog = true
    },
    showAssignOperatorsDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.assignOperatorsDialog = true
    },
    showVersionConfigurationDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.versionConfigurationDialog = true
    },
    showFiveCodeDialog() {
      this.fiveWayCodeUploadDialog = true
    },
    showDetailsDialog(row) {
      console.log('ebikeCode====', row)
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      this.eBikeBaseInfo.ebikeCode = row.ebikeCode
      // this.getBikeDetails()
      // this.getMaintainRecordList(row.ebikeId)
      // this.showBaseInfoType = 1
      this.eBikeDetailsDialog = true
      // this.timer = setInterval(this.getBikeDetails, 5000)
    },
    showBaseInfo(type) {
      this.showBaseInfoType = type
    },
    showBaseInfoDialog() {
      this.eBikeBaseInfoDialog = true
    },
    handlerDelBike() {
      this.$confirm(this.$t('bike.name381'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          removeIotEbike({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
            if (res.code === 200) {
              this.closeBaseInfoDialog()
              this.eBikeDetailsDialog = false
              if (this.$refs.vehicleDetailsDialog) {
                this.$refs.vehicleDetailsDialog.close()
              }
              this.getPageList()
              this.$message({ type: 'success', message: this.$t('public.name30') })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handlerModify() {
      this.loading3 = true
      modifyEbikeBaseInfo(this.eBikeBaseInfo)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
              if (res.code === 200) {
                this.eBikeDetails = res.data.iotEbike
              }
            })
            this.closeBaseInfoDialog()
          }
        })
        .catch(() => {
          this.loading3 = false
        })
    },
    closeBaseInfoDialog() {
      this.eBikeBaseInfoDialog = false
      this.eBikeBaseInfo.remark = ''
      // this.pageSize = 10
      // this.pageNumber = 1
      // this.alarmTotal = 0
      // this.alarmMessageList = []
    },
    showIotDetailsDialog(row) {
      this.iotEbikeId = row.ebikeId
      this.iotDetailsDialog = true
    },
    closeIotDetailsDialog() {
      if (this.$refs.iotDetailsDialogRef) {
        this.$refs.iotDetailsDialogRef.close()
      }
      this.iotDetailsDialog = false
      this.iotEbikeId = ''
    },
    submitVersionConfiguration() {
      this.$refs.versionConfigurationFormRef.validate((valid) => {
        if (valid) {
          this.loading2 = true
          this.versionConfigurationForm.ebikeIdList = []
          this.selectionList.map((item, index) => {
            this.versionConfigurationForm.ebikeIdList.push(item.ebikeId)
          })
          sendUpgradeInfo(this.versionConfigurationForm)
            .then((res) => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitAssignOperators() {
      this.$refs.assignOperatorsFormRef.validate(valid => {
        if (valid) {
          this.loading2 = true
          const ebikeIdList = []
          this.selectionList.map((item, index) => {
            ebikeIdList.push(item.ebikeId)
          })
          tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.assignOperatorsForm.tenantId })
            .then(res => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('public.name32'), this.$t('public.name23'), {
            confirmButtonText: this.$t('public.name25'),
            cancelButtonText: this.$t('public.name14'),
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.table.clearSelection()
                    this.close()
                    this.queryList()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('public.name33')
              })
            })
        } else {
          return false
        }
      })
    },
    changeTransportMode() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      if (this.selectionList.length > 1) {
        this.$message.warning(this.$t('bike.name382'))
        return
      }
      const ebikeIdList = []
      this.selectionList.map((item, index) => {
        ebikeIdList.push(item.ebikeId)
      })
      this.$confirm(this.$t('bike.name383'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.loading1 = true
          sendTransportInfo({ ebikeId: ebikeIdList[0] })
            .then(res => {
              this.loading1 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading1 = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    close() {
      if (this.$refs.vehicleDetailsDialog) {
        this.$refs.vehicleDetailsDialog.close()
      }
      this.closeIotDetailsDialog()
      this.vehicleModelBindingDialog = false
      this.assignOperatorsDialog = false
      this.assignOperatorsForm = {
        tenantId: ''
      }
      this.versionConfigurationDialog = false
      this.fiveWayCodeUploadDialog = false
      this.eBikeDetailsDialog = false
      this.bindingForm = {
        ebikeModelId: '',
        ebikeIdList: []
      }
      this.importIotNumDialog = false
      this.addIotNumDialog = false
      this.belong = {
        tenantId: ''
      }
      this.importBelong = {
        tenantId: ''
      }
      this.versionConfigurationForm = {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: []
      }
      this.versionConfigurationDialog = false
      this.iotDialog = false
    },
    getPageList() {
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    buildBikeListParams (pageNumber, pageSize) {
      return {
        ...this.queryInfo,
        pageNumber,
        pageSize,
        ebikeId: (this.queryInfo.ebikeId || '').trim(),
        controllerEdition: (this.queryInfo.controllerEdition || '').trim(),
        meterEdition: (this.queryInfo.meterEdition || '').trim(),
        iotEdition: (this.queryInfo.iotEdition || '').trim()
      }
    },
    async queryList() {
      this.tableLoading = true
      try {
        const params = this.buildBikeListParams(this.queryInfo.pageNumber, this.queryInfo.pageSize)
        const res = await findEbikePage(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.page && res.data.page.records) || []
          this.total = (res.data && res.data.page && res.data.page.total) || 0
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getBikeList() {
      return this.queryList()
    },
    showModeBindDialog() {
      if (this.selectionList.length > 0) {
        this.selectionList.map((item, index) => {
          this.bindingForm.ebikeIdList.push(item.ebikeId)
        })
        this.vehicleModelBindingDialog = true
      } else {
        this.$message.warning(this.$t('bike.name380'))
      }
    },
    bindingVehicleMode() {
      this.$refs.bindingFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          bindModel(this.bindingForm).then(res => {
            this.loading = false

            console.log('===', res.code)
            if (res.code === 200) {
              this.queryList()
              this.$refs.table.clearSelection()
              this.close()
            }
          }).catch(() => {
            this.loading = false
          })
          this.close()
        } else {
          return false
        }
      })
    },
    handleCancelBindModel(row) {
      this.$confirm(this.$t('bike.name384'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          cancelBindModel({ ebikeIdList: [row.ebikeId] }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('bike.name385')
              })
              this.queryInfo.pageNumber = 1
              this.queryList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('bike.name386')
          })
        })
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    loadOptions(node, resolve) {
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    loadOptions1() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
            this.manufacturerOptions = options
            this.uploadTenantId = this.manufacturerOptions[0].value
          } else {
            this.manufacturerOptions = []
          }
        })
        .catch(() => {})
    },
    versionLoadOptions(node, resolve) {
      console.log('====', node)
      let data = {
        pageNumber: 1,
        pageSize: 500
      }
      if (node.level === 1) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          tenantId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          parentId: node.value
        }
      }
      findOtaFirmwarePage(data).then((res) => {
        var options = []
        if (node.level === 0) {
          options = res.data.page.records.map((item) => ({ value: item.tenantId, label: item.tenantName, leaf: node.level >= 2 }))
        }
        if (node.level === 1) {
          options = res.data.page.records.map((item) => ({ value: item.firmwareType, label: ['IOT', this.$t('bike.name14'), this.$t('bike.name413')][item.firmwareType], leaf: node.level >= 2 }))
        }
        resolve(options)
      }).catch(() => {})
    },
    handleVersionChange(value) {},
    handleChange(value) {
      console.log('value===', value)
      // 处理选项变化
      this.belong.tenantId = value[value.length - 1]
      this.importBelong.tenantId = value[value.length - 1]
      // this.addEBikeInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    handleChange1(value) {
      console.log('value===', value)
      // 处理选项变化
      this.queryInfo.permTenantList = []
      if (value.length > 0) {
        value.map((item) => {
          this.queryInfo.permTenantList.push(item[item.length - 1])
        })
      }
      console.log('value===', this.queryInfo.permTenantList)
      // const panelRefs = this.$refs.refHandle.$refs.panel
      // if (panelRefs.activePath.length !== 0) {
      //   panelRefs.activePath.forEach(item => {
      //     if (item.children.length === 0) {
      //       panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      //     }
      //   })
      // }
      this.getPageList()
    },
    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          loading.close()
          downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
          this.queryList()
        })
        .catch(res => {
          loading.close()
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    },

    // 导入五通码
    Importbike() {
      this.ImportbikeVisible = true
    },
    ImportbikeDialogBefore() {
      this.ImportbikeVisible = false
    },
    // uploadFile(file) {
    //   this.fiveWayCodeFile = file
    // },
    delFile() {
      this.fiveWayCodeFile = null
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
    },
    uploadSectionFile1() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeVin(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name388'))
          } else {
            this.$confirm(this.$t('bike.name389'), this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name390'), 'xlsx', true)
            }).catch(() => {})
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.fiveWayCodeUploadDialog = false
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    uploadSectionFile2() {
      if (this.fiveWayCodeFile === null) {
        this.$message.error(this.$t('public.name38'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.importBelong.tenantId)
      this.loading2 = true
      importTenantBindEbike(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            // console.log('res====2', res)
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name389'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name391'))
            }
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.importIotNumDialog = false
          this.importBelong.tenantId = ''
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    showIOTDialog() {
      this.iotDialog = true
    },
    uploadSectionFile3() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          this.loading2 = false
          // console.log('res====1', res)
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name389'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name391'))
            }
          }
          this.getPageList()
          this.iotDialog = false
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },

    onUploadSuccess() {
      this.$message.success(this.$t('public.name64'))
      this.$refs.uploadss.clearFiles()
      this.ImportbikeVisible = false
      this.getBikes()
    },
    beforebikeupload(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (size > 50) {
        this.$message.warning(this.$t('public.name65'))
        return false
      }
      if (extension !== 'xlsx') {
        this.$message.warning(this.$t('public.name66'))
        return false
      }
    },
    getOtaFirmwareInfoLlist2() {
      const data = {
        tenantId: this.userinfo.tenantId
      }
      otaFirmwareInfoList2(data)
        .then((res) => {
          res.data.map((item) => {
            this.typeAllOptions.map((items) => {
              if (item === items.name) {
                const obj = {}
                obj.name = items.name
                obj.label = items.label
                this.typeOptions.push(obj)
              }
            })
          })
        })
        .catch(() => {
          this.typeOptions = []
        })
    },
    changeType(e) {
      const data = {
        tenantId: this.userinfo.tenantId,
        firmwareType: e
      }
      otaFirmwareInfoList3(data)
        .then((res) => {
          this.versionNumberOptions = res.data
        })
        .catch(() => {
          this.versionNumberOptions = []
        })
    },
    showAddBikeDialog() {
      this.addBikeDialog = true
    },
    closeAddBikeDialog() {
      this.addBikeDialog = false
      this.addEBikeInfo = {
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      }
    },
    handlerAddBike() {
      this.$refs.addBikeRef.validate(valid => {
        if (valid) {
          this.loading3 = true
          // if (Array.isArray(this.addEBikeInfo.tenantId)) {
          //   this.addEBikeInfo.tenantId = this.addEBikeInfo.tenantId[0]
          // }
          addEbike(this.addEBikeInfo).then(res => {
            this.loading3 = false
            if (res.code === 200) {
              this.queryList()
              this.closeAddBikeDialog()
            }
          }).catch(() => {
            this.loading3 = false
          })
        } else {
          return false
        }
      })
    },
    importProductDialog() {
      this.productUploadDialog = true
    },
    resetIOT (row) {
      this.$confirm(
        this.$t('bike.name599', { ebikeId: row.ebikeId, action: this.$t('bike.name531') }),
        this.$t('public.name23'),
        {
          confirmButtonText: this.$t('public.name25'),
          cancelButtonText: this.$t('public.name14'),
          type: 'warning'
        }
      ).then(() => {
        // 国内/海外：IOT重置均仅清库；擦除见 eraseIotParts
        this.doResetIotEbike(row.ebikeId)
      }).catch(() => {})
    },
    // 国内/海外共用的清库重置（仅 resetIotEbike）
    doResetIotEbike (ebikeId) {
      resetIotEbike({ ebikeId })
        .then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name532'))
            this.queryList()
          }
        })
        .catch(() => {})
    },
    // 海外擦除：仅 unbindParts + 轮询 getHandleResult；成功 name608，失败/超时 name605；不调 resetIotEbike
    eraseIotParts (row) {
      const ebikeId = row.ebikeId
      if (this.buttonPerms.indexOf('ebikeControl/unbindParts') === -1) {
        this.$message.warning(this.$t('apiMessage.name23'))
        return
      }
      if (this.isControlPending(ebikeId)) {
        this.$message.warning(this.$t('bike.name598'))
        return
      }
      this.$confirm(
        this.$t('bike.name599', { ebikeId, action: this.$t('bike.name610') }),
        this.$t('public.name23'),
        {
          confirmButtonText: this.$t('public.name25'),
          cancelButtonText: this.$t('public.name14'),
          type: 'warning'
        }
      ).then(() => {
        this.$set(this.controlPending, ebikeId, true)
        unbindParts({ ebikeId }).then(res => {
          if (res && res.code === 200 && res.data && res.data.msgId) {
            this.$message.info(this.$t('bike.name597'))
            this.pollUnbindErase(ebikeId, res.data.msgId)
          } else {
            this.$set(this.controlPending, ebikeId, false)
            this.$message.error(this.$t('bike.name605', { ebikeId }))
          }
        }).catch(() => {
          this.$set(this.controlPending, ebikeId, false)
          this.$message.error(this.$t('bike.name605', { ebikeId }))
        })
      }).catch(() => {})
    },
    // 擦除结果轮询：result 1=SUCCESS / 2=FAIL；约每 3s，最多 3 次（~9s）；PENDING 则继续，超时提示 name605
    pollUnbindErase (ebikeId, msgId) {
      const MAX_RETRY = 3
      let retry = 0
      const poll = () => {
        getHandleResult({ msgId }).then(res => {
          if (res && res.code === 200 && res.data) {
            const result = res.data.result
            if (result === 1) {
              this.clearControlTimer(ebikeId)
              this.$set(this.controlPending, ebikeId, false)
              this.$message.success(this.$t('bike.name608', { ebikeId }))
              return
            }
            if (result === 2) {
              this.clearControlTimer(ebikeId)
              this.$set(this.controlPending, ebikeId, false)
              this.$message.error(this.$t('bike.name605', { ebikeId }))
              return
            }
          } else {
            this.clearControlTimer(ebikeId)
            this.$set(this.controlPending, ebikeId, false)
            this.$message.error(this.$t('bike.name605', { ebikeId }))
            return
          }
          retry += 1
          if (retry >= MAX_RETRY) {
            this.clearControlTimer(ebikeId)
            this.$set(this.controlPending, ebikeId, false)
            this.$message.error(this.$t('bike.name605', { ebikeId }))
            return
          }
          this.controlTimers[ebikeId] = setTimeout(poll, 3000)
        }).catch(() => {
          retry += 1
          if (retry >= MAX_RETRY) {
            this.clearControlTimer(ebikeId)
            this.$set(this.controlPending, ebikeId, false)
            this.$message.error(this.$t('bike.name605', { ebikeId }))
            return
          }
          this.controlTimers[ebikeId] = setTimeout(poll, 3000)
        })
      }
      this.controlTimers[ebikeId] = setTimeout(poll, 3000)
    },
    isControlPending (ebikeId) {
      return !!this.controlPending[ebikeId]
    },
    // 开关锁按钮：仅当具备「当前状态对应」的接口权限时显示
    canToggleLockFor (lockStatus) {
      const perm = lockStatus === 0
        ? 'ebikeControl/remoteDisable'
        : 'ebikeControl/remoteEnable'
      return this.buttonPerms.indexOf(perm) > -1
    },
    lockStatusLabel (lockStatus) {
      if (lockStatus === 0) return this.$t('bike.name224')
      if (lockStatus === 4) return this.$t('bike.name601')
      return this.$t('bike.name225')
    },
    // 解锁态 → 开启远程锁定(R1/remoteDisable)；锁定态 → 关闭远程锁定(R2/remoteEnable)
    toggleLockLabel (lockStatus) {
      return lockStatus === 0 ? this.$t('bike.name603') : this.$t('bike.name604')
    },
    handleToggleLock (row) {
      if (!this.canToggleLockFor(row.lockStatus)) return
      const command = row.lockStatus === 0 ? 'remoteDisable' : 'remoteEnable'
      const actionLabel = this.toggleLockLabel(row.lockStatus)
      this.confirmAndExecuteControl(command, row, actionLabel)
    },
    handleOverseasIotMenuCommand (command, row) {
      if (command === 'iot') {
        this.showIotDetailsDialog(row)
        return
      }
      if (command === 'production') {
        this.showCertificateDialog(row)
        return
      }
      if (command === 'erase') {
        this.eraseIotParts(row)
        return
      }
      if (command === 'reset') {
        this.resetIOT(row)
        return
      }
      const actionLabelMap = {
        remoteUnlockBattery: this.$t('bike.name590'),
        remoteLockBattery: this.$t('bike.name591')
      }
      this.confirmAndExecuteControl(command, row, actionLabelMap[command])
    },
    confirmAndExecuteControl (command, row, actionLabel) {
      if (this.isControlPending(row.ebikeId)) {
        this.$message.warning(this.$t('bike.name598'))
        return
      }
      const confirmMsg = this.$t('bike.name599', { ebikeId: row.ebikeId, action: actionLabel })
      this.$confirm(confirmMsg, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      }).then(() => {
        this.executeControl(command, row, actionLabel)
      }).catch(() => {})
    },
    executeControl (command, row, actionLabel) {
      const ebikeId = row.ebikeId
      const apiMap = { remoteEnable, remoteDisable, remoteUnlockBattery, remoteLockBattery }
      const api = apiMap[command]
      if (!api) return
      this.$set(this.controlPending, ebikeId, true)
      this.$set(this.controlActionLabel, ebikeId, actionLabel || '')
      api({ ebikeId }).then(res => {
        if (res && res.code === 200 && res.data && res.data.msgId) {
          this.$message.info(this.$t('bike.name597'))
          this.pollHandleResult(ebikeId, res.data.msgId)
        } else {
          this.$set(this.controlPending, ebikeId, false)
          this.$message.error((res && res.errorMsg) || (actionLabel
            ? this.$t('bike.name606', { ebikeId, action: actionLabel })
            : this.$t('bike.name595', { ebikeId })))
        }
      }).catch(() => {
        this.$set(this.controlPending, ebikeId, false)
        this.$message.error(actionLabel
          ? this.$t('bike.name606', { ebikeId, action: actionLabel })
          : this.$t('bike.name595', { ebikeId }))
      })
    },
    pollHandleResult (ebikeId, msgId) {
      const MAX_RETRY = 3
      let retry = 0
      const poll = () => {
        getHandleResult({ msgId }).then(res => {
          if (res && res.code === 200 && res.data) {
            const result = res.data.result
            if (result === 1) {
              this.finishControl(ebikeId, true)
              return
            }
            if (result === 2) {
              this.finishControl(ebikeId, false)
              return
            }
          } else {
            this.finishControl(ebikeId, null)
            return
          }
          retry += 1
          if (retry >= MAX_RETRY) {
            this.finishControl(ebikeId, null)
            return
          }
          this.controlTimers[ebikeId] = setTimeout(poll, 3000)
        }).catch(() => {
          retry += 1
          if (retry >= MAX_RETRY) {
            this.finishControl(ebikeId, null)
            return
          }
          this.controlTimers[ebikeId] = setTimeout(poll, 3000)
        })
      }
      this.controlTimers[ebikeId] = setTimeout(poll, 3000)
    },
    finishControl (ebikeId, success) {
      this.clearControlTimer(ebikeId)
      this.$set(this.controlPending, ebikeId, false)
      const actionLabel = this.controlActionLabel[ebikeId]
      delete this.controlActionLabel[ebikeId]
      if (success === true) {
        this.$message.success(this.$t('bike.name594', { ebikeId, action: actionLabel || '' }))
        this.queryList()
      } else if (success === false) {
        this.$message.error(actionLabel
          ? this.$t('bike.name606', { ebikeId, action: actionLabel })
          : this.$t('bike.name595', { ebikeId }))
      } else {
        this.$message.warning(this.$t('bike.name596', { ebikeId }))
      }
    },
    clearControlTimer (ebikeId) {
      if (this.controlTimers[ebikeId]) {
        clearTimeout(this.controlTimers[ebikeId])
        delete this.controlTimers[ebikeId]
      }
    },
    clearAllControlTimers () {
      Object.keys(this.controlTimers || {}).forEach(ebikeId => {
        clearTimeout(this.controlTimers[ebikeId])
      })
      this.controlTimers = {}
    },
    closeProductUpload() {
      this.productUploadDialog = false
      this.tenantIds2 = []
    },
    handleChange2(value) {
      // 处理选项变化
      this.uploadTenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle2.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    uploadSectionFile4() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('tenantId', this.uploadTenantId)
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importCertificate(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name393'))
          } else {
            this.$confirm(this.$t('bike.name394'), this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name395'), 'xlsx', true)
            }).catch(() => {})
          }
          this.getPageList()
          this.productUploadDialog = false
          this.fiveWayCodeFile = null
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    importBikeInfoDialog() {
      this.bikeUploadDialog = true
    },
    importBikeFactoryDialog() {
      this.bikeFactoryUploadDialog = true
    },
    closeBikeUpload() {
      this.bikeUploadDialog = false
      this.bikeFactoryUploadDialog = false
      this.tenantIds2 = []
    },
    uploadSectionFile5() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeBaseInfo(formData)
        .then(res => {
          this.loading3 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name396'))
          } else {
            this.$confirm(this.$t('bike.name397'), this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name398'), 'xlsx', true)
            }).catch(() => {})
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.bikeUploadDialog = false
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading3 = false
        })
    },
    uploadSectionFile6() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeModelCertificateConformity(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name399'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name400'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name401'))
            }
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.bikeFactoryUploadDialog = false
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    showCertificateDialog(row) {
      selecteById({ id: row.eccId })
        .then(res => {
          this.certificateDetails = res.data || {}
        })
        .catch(res => {
          this.certificateDetails = {}
        })
      this.certificateDialog = true
    },
    closeCertificateDialog() {
      this.certificateDialog = false
    },
    getMaintainRecordList(ebikeId) {
      queryWebMaintainRecordListByEbikeId({ ebikeId: ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.maintenanceRecordList = res.data
            this.pos = 0
            this.spanArr = []
            this.getSpanArr(this.maintenanceRecordList)
          }
        })
        .catch(() => {
        })
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].id === data[i - 1].id &&
            data[i].tenantName === data[i - 1].tenantName &&
            data[i].createTime === data[i - 1].createTime &&
            data[i].storeAddress === data[i - 1].storeAddress
          ) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 6) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    }
    // handleMaintenanceSizeChange(newSize) {
    //   this.maintenanceRecord.pageSize = newSize
    //   this.getMaintainRecordList()
    // },
    // handleMaintenanceChange(newPage) {
    //   this.maintenanceRecord.pageNumber = newPage
    //   this.getMaintainRecordList()
    // }
  }
}
</script>
<style lang="scss">
.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*打开时文字位置设置*/
.switch .el-switch__label--right {
  z-index: 1;
}

/* 调整打开时文字的显示位子 */
.switch .el-switch__label--right span {
  margin-left: 9px;
}

/*关闭时文字位置设置*/
.switch .el-switch__label--left {
  z-index: 1;
}

/* 调整关闭时文字的显示位子 */
.switch .el-switch__label--left span {
  margin-left: 22px;
}

/*显示文字*/
.switch .el-switch__label.is-active {
  display: block;
}

/* 调整按钮的宽度 */
.switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 50px !important;
  margin: 0;
}

</style>

<style lang="scss" scoped>
.bikelist-container {
  display: flex;
  flex-direction: column;
  .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .add-user{
    display: flex;
    flex-direction: row;
  }

  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      width: 50%;
      text-align: center;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }

  .control-more-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-left: 8px;
    color: #0f73e6;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #409eff;
    }
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
</style>
